module.exports = require("plugin-assets/shared/widget/editor/preview/widget-empty-state");